export default "__VITE_ASSET__5DhPCGBf__"